import { InjectionToken } from '@angular/core';
import { ApiRoutes } from '../../shared/models/api-routes.interface';
import { LocalstorageTokensKeys } from '../../shared/models/tokens-keys.interface';

export const API_ROUTES = new InjectionToken<ApiRoutes>('marid.api.routes');
export const LOCALSTORAGE_TOKENS = new InjectionToken<LocalstorageTokensKeys>(
  'marid.localstorage.tokens',
);
export const BASE_API_URL = new InjectionToken<string>('marid.base.api.url');
